import { get_game_results } from "@quiz-buzz/client-common";
import { useSelector } from "@xstate/react";
import { style } from "typestyle";
import { player_machine_actor } from "../App/main";


export const Game_Results_Component = () => {
    

    const { teams, players, teams_enabled } = useSelector(player_machine_actor, (state) => state.context)

    const results = get_game_results(teams, players, teams_enabled)
    
    if (teams_enabled) {
        if (results.is_draw) {
            return (
                <>
                    <div className={results_box_style}>
                        <div className={results_box_header_style}>It's a draw!</div>
                        <div className={results_box_winners_style}>
                            Congratulations to{' '}
                            <div className={winner_list_style}>
                                {results.team_winners.map(team => team.name).join(', ')}
                            </div>
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div className={results_box_style}>
                        <div className={results_box_header_style}>We have a winner!</div>
                        <div className={results_box_winners_style}>
                            Congratulations to{' '}
                            <div className={winner_list_style}>
                                {results.team_winners[0].name}
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    } else {
        if (results.is_draw) {
            return (
                <>
                    <div className="results_box">
                        <div className={results_box_header_style}>It's a draw!</div>
                        <div className={results_box_winners_style}>
                            Congratulations to{' '}
                            <div className={winner_list_style}>
                                {results.player_winners.map(player => player.name).join(', ')}
                            </div>
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div className="results_box">
                        <div className={results_box_header_style}>We have a winner!</div>
                        <div className={results_box_winners_style}>
                            Congratulations to{' '}
                            <div className={winner_list_style}>
                                {results.player_winners[0].name}
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}


const results_box_style = style({
	margin: 'auto',
	transform: 'rotate(-8deg)',
	textAlign: 'center',
})

const results_box_header_style = style({
	fontFamily: '"Titan One", sans-serif',
	fontSize: '3rem',
})

const results_box_winners_style = style({
})

const winner_list_style = style({
	fontSize: '2em',
	backgroundImage: 'linear-gradient(#dacc34, #9b8722)',
})